import { render, staticRenderFns } from "./dict-detail.vue?vue&type=template&id=c5ca915a&scoped=true&"
import script from "./dict-detail.vue?vue&type=script&lang=js&"
export * from "./dict-detail.vue?vue&type=script&lang=js&"
import style0 from "./dict-detail.vue?vue&type=style&index=0&id=c5ca915a&lang=less&scoped=true&"
import style1 from "@/assets/less/i-switch.less?vue&type=style&index=1&id=c5ca915a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ca915a",
  null
  
)

component.options.__file = "dict-detail.vue"
export default component.exports